var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:'overview_graph_change ' + _vm.className()},[_vm._v("\n    "+_vm._s(_vm.validValue() ? ((_vm.diffPercent > 0 ? '+' : '') + _vm.diffPercent.toFixed(0) + ' %') : '')+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bfb12ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/templates/part/ui/overview-graph-change.vue
// module id = null
// module chunks = 